import { FC } from "react";

import { Dialog, SxProps, Theme } from "@mui/material";

import { DashboardDrawer } from "@/dashboard-design-system/Drawer";
import { useMediaQuery } from "@/hooks/useMediaQuery";

type ShareFormModalProps = {
  open: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

export const ShareFormModal: FC<ShareFormModalProps> = ({ open, onClose, children, sx }) => {
  const { isSmallScreen } = useMediaQuery();

  if (isSmallScreen) {
    return (
      <DashboardDrawer
        onClose={onClose}
        open={open}
        anchor="bottom"
        data-test="share-form-modal"
        slots={{
          header: <></>, // Show the drawer as if it has a header since it's rendered within the content
        }}
        noPadding
        hasStickyHeader
        sx={sx}
      >
        {children}
      </DashboardDrawer>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth data-test="share-form-modal" sx={sx}>
      {children}
    </Dialog>
  );
};
